export * from '@fhs/routing/src/routes/store-locator/address';
export { default } from '@fhs/routing/src/routes/store-locator/address';
